import client from './client';

export const CATEGORY_RESOURCES = {
  bhajans: {
    path: '/api/bhajans/categories/',
    params: (p = {}) => p,
  },
  publications: {
    path: '/api/publications/categories/',
    params: (p = {}) => p,
  },
  gallery: {
    path: '/api/gallery/categories/',
    params: (p = {}) => p,
  },
  videos: {
    path: '/api/videos/categories/',
    params: (p = {}) => p,
  },
};

/**
 * CRUD operations for a category resource (bhajans / publications / gallery).
 * `resource` must be one of CATEGORY_RESOURCES keys.
 */
export const createCategoryApi = (resource) => {
  const cfg = CATEGORY_RESOURCES[resource];
  if (!cfg) throw new Error(`Unknown category resource: ${resource}`);

  const base = () => cfg.path.replace(/\/+$/, '');

  return {
    list(params = {}) {
      return client.get(`${base()}/`, { params: cfg.params(params) }).then((r) => r.data);
    },

    create(payload) {
      return client.post(`${base()}/`, payload).then((r) => r.data);
    },

    update(slug, payload) {
      return client.patch(`${base()}/${slug}/`, payload).then((r) => r.data);
    },

    remove(slug) {
      return client.delete(`${base()}/${slug}/`).then((r) => r.data);
    },
  };
};
